import { library, IconDefinition, IconPack } from "@fortawesome/fontawesome-svg-core";
import * as iconLibrary from "./library";

type IconDefinitionOrPack = IconDefinition | IconPack;

library.add(iconLibrary as IconDefinitionOrPack);

export {};
